import React from 'react'

function Close() {
    return (
        <>
            Close
        </>
    )
};
export default Close;